import { getSignsimpliEndPoint, endPoints } from "./api-constants";
import { getAuthHeader, readCookie } from "../utils/helpers";
import { apiService } from "../services/base-api-service";

class SignSimpliController {
  SignSimpli(url) {
    return getSignsimpliEndPoint(url);
  }
  addWizard(data) {
    const getDocumentProfileEndPoint = this.SignSimpli(`${endPoints.signsimpliController.ADD_WIZARD}`);
    return apiService.post(getDocumentProfileEndPoint, data, getAuthHeader());
  }
}
export default new SignSimpliController();
